<!-- eslint-disable linebreak-style -->
<template>
    <svg
        id="Pipeline"
        xmlns="http://www.w3.org/2000/svg"
        style="width: 100px;"
        :width="width"
        :height="height"
        viewBox="0 0 82.714 37.127"
    >
        <g
            id="Trazado_671"
            transform="translate(-536.184 -220.373)"
            fill="#0088d6"
            stroke-miterlimit="10"
        >
            <path
                d="M609.362,257.5H538.4a2.216,2.216,0,0,1-2.023-3.122l6.508-14.535a2.215,2.215,0,0,0,0-1.811L536.38,223.5a2.217,2.217,0,0,1,2.023-3.123h70.959a2.217,2.217,0,0,1,2.023,1.311l7.32,16.347a2.219,2.219,0,0,1,0,1.811l-7.32,16.347A2.217,2.217,0,0,1,609.362,257.5Z"
                stroke="none"
            />
            <path
                d="M 609.3619995117188 256.4998474121094 C 609.8407592773438 256.4998474121094 610.2766723632812 256.2174377441406 610.472412109375 255.7806243896484 L 617.7918090820312 239.4342346191406 C 617.9332275390625 239.1180419921875 617.9332275390625 238.7553558349609 617.7920532226562 238.4396209716797 L 610.4725952148438 222.0930328369141 C 610.2765502929688 221.6556091308594 609.8406372070312 221.3729705810547 609.3619995117188 221.3729705810547 L 538.4033813476562 221.3729705810547 C 537.983154296875 221.3729705810547 537.6109619140625 221.5753631591797 537.3823852539062 221.9282379150391 C 537.15380859375 222.2810363769531 537.1212158203125 222.7033081054688 537.29296875 223.0868377685547 L 543.80126953125 237.6221008300781 C 544.175537109375 238.45751953125 544.175537109375 239.4158325195312 543.8013305664062 240.2510833740234 L 537.2929077148438 254.7865905761719 C 537.1212158203125 255.1699371337891 537.15380859375 255.5920562744141 537.3822021484375 255.9446563720703 C 537.61083984375 256.2974853515625 537.9830322265625 256.4998474121094 538.4033813476562 256.4998474121094 L 609.3619995117188 256.4998474121094 M 609.3619995117188 257.4998474121094 L 538.4033813476562 257.4998474121094 C 536.7969360351562 257.4998474121094 535.7236328125 255.8440856933594 536.3802490234375 254.3778686523438 L 542.888671875 239.8424224853516 C 543.1468505859375 239.2661285400391 543.1468505859375 238.6072387695312 542.888671875 238.0309600830078 L 536.3802490234375 223.4954986572266 C 535.7236328125 222.0292663574219 536.7969360351562 220.3729705810547 538.4033813476562 220.3729705810547 L 609.3619995117188 220.3729705810547 C 610.2359008789062 220.3729705810547 611.0277709960938 220.8866729736328 611.3851318359375 221.6840667724609 L 618.7047119140625 238.0309600830078 C 618.96240234375 238.6072387695312 618.96240234375 239.2661285400391 618.7047119140625 239.8424224853516 L 611.3851318359375 256.1893005371094 C 611.0277709960938 256.9866943359375 610.2359008789062 257.4998474121094 609.3619995117188 257.4998474121094 Z"
                stroke="none"
                fill="rgba(0,136,214,0.6)"
            />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        height: {
            type: Number,
            default() {
                return 37.127;
            }
        },
        width: {
            type: Number,
            default() {
                return 82.714;
            }
        }
    }
};
</script>
